<div class="filter-group" data-group-visibility-id="showSalvagingGearFiltersPoe2">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showSalvagingGearFiltersPoe2" (click)="filter.groupVisibility.showSalvagingGearFiltersPoe2 = !filter.groupVisibility.showSalvagingGearFiltersPoe2; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="{{ poe1 ? 'Quality & Linked Gear' : 'Disenchanting, Selling & Salvaging Gear' }}" [activeRules]="activeRules.salvagingGearFiltersPoe2"></span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showSalvagingGearFiltersPoe2) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showSalvagingGearFiltersPoe2">

      <app-vendoring-gear [filter]="filter" [includeMagics]="true"></app-vendoring-gear>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showSocketedGear">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showSocketedGear"
            (click)="toggleShowSocketedGear()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Socketed Gear" ruleId="gear-salvaging-sockets" [additionalContent]="socketedGearStylePreview">
            <ng-template #socketedGearStylePreview>
              <app-equipment-tier-picker
                [sockets]="'WW'"
                [equipmentType]="EquipmentType.OtherGearSalvagingSocketed"
                [active]="filter.showSocketedGear"
                [disabled]="!filter.showSocketedGear"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-select style="width: 130px" [fullWidth]="true" [disabled]="!filter.showSocketedGear" [(ngModel)]="filter.showSocketedGearType" (selectedValueChange)="updateFilter()">
            <app-option [value]="SocketedItemType.All" [text]="'All'"></app-option>
            <app-option [value]="SocketedItemType.TwoOrMoreSockets" [text]="'2 Sockets'"></app-option>
          </app-select>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showQualityMartialWeapons">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showQualityMartialWeapons"
            (click)="toggleShowQualityMartialWeapons()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Quality Martial Weapons" ruleId="gear-salvaging-quality-weapons-martial" [additionalContent]="qualityMartialWeaponsStylePreview">
            <ng-template #qualityMartialWeaponsStylePreview>
              <app-equipment-tier-picker
                exampleName="Superior Martial Weapon"
                [equipmentType]="EquipmentType.OtherGearSalvagingQualityMartialWeapons"
                [active]="filter.showQualityMartialWeapons"
                [disabled]="!filter.showQualityMartialWeapons"></app-equipment-tier-picker>
            </ng-template>
          </span>
          @if (!isMobile()) {
          <span class="sep"></span>
            <div class="filter-title filter-label">
              Of Quality
            </div>
          }
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showQualityMartialWeapons"
            [(ngModel)]="filter.showQualityMartialWeaponsMinQuality" (change)="updateFilter()">
          <span class="sep"></span>
          <app-select-gear-size
            [allowedSizes]="[GearSizeType.All, GearSizeType.MediumOnly, GearSizeType.SmallOnly]"
            [disabled]="!filter.showQualityMartialWeapons"
            [(ngModel)]="filter.showQualityMartialWeaponsSize"
            (selectedValueChange)="updateFilter()"></app-select-gear-size>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showQualityCasterWeapons">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showQualityCasterWeapons"
            (click)="toggleShowQualityCasterWeapons()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Quality Caster Weapons" ruleId="gear-salvaging-quality-weapons-caster" [additionalContent]="qualityCasterWeaponsStylePreview">
            Staves, Sceptres and Wands.
            <ng-template #qualityCasterWeaponsStylePreview>
              <app-equipment-tier-picker
                exampleName="Superior Caster Weapon"
                [equipmentType]="EquipmentType.OtherGearSalvagingQualityCasterWeapons"
                [active]="filter.showQualityCasterWeapons"
                [disabled]="!filter.showQualityCasterWeapons"></app-equipment-tier-picker>
            </ng-template>
          </span>
          @if (!isMobile()) {
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Of Quality
            </div>
          }
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showQualityCasterWeapons"
            [(ngModel)]="filter.showQualityCasterWeaponsMinQuality" (change)="updateFilter()">
          <span class="sep"></span>
          <app-select-gear-size
            [allowedSizes]="[GearSizeType.All, GearSizeType.MediumOnly, GearSizeType.SmallOnly]"
            [disabled]="!filter.showQualityCasterWeapons"
            [(ngModel)]="filter.showQualityCasterWeaponsSize"
            (selectedValueChange)="updateFilter()"></app-select-gear-size>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showQualityArmour">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showQualityArmour"
            (click)="toggleShowQualityArmour()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Quality Shields and Armour" ruleId="gear-salvaging-quality-armour" [prefixMatch]="true" [additionalContent]="qualityArmourStylePreview">
            <ng-template #qualityArmourStylePreview>
              <app-equipment-tier-picker
                exampleName="Superior Armour"
                [equipmentType]="EquipmentType.OtherGearSalvagingQualityArmour"
                [active]="filter.showQualityArmour"
                [disabled]="!filter.showQualityArmour"></app-equipment-tier-picker>
            </ng-template>
          </span>
          @if (!isMobile()) {
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Of Quality
            </div>
          }
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showQualityArmour"
            [(ngModel)]="filter.showQualityArmourMinQuality" (change)="updateFilter()">
          <span class="sep"></span>
          <app-select-gear-size
            [allowedSizes]="[GearSizeType.All, GearSizeType.MediumOnly, GearSizeType.TwoByTwoOnly]"
            [disabled]="!filter.showQualityArmour"
            [(ngModel)]="filter.showQualityArmourSize"
            (selectedValueChange)="updateFilter()"></app-select-gear-size>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showQualityFlasks">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showQualityFlasks"
            (click)="toggleShowQualityFlasks()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Quality Flasks" ruleId="flasks-salvaging-quality" [additionalContent]="qualityFlasksStylePreview">
            <ng-template #qualityFlasksStylePreview>
              <app-equipment-tier-picker
                exampleName="Superior Ultimate Life Flask"
                [equipmentType]="EquipmentType.OtherFlasksQuality"
                [active]="filter.showQualityFlasks"
                [disabled]="!filter.showQualityFlasks"></app-equipment-tier-picker>
            </ng-template>
          </span>
          @if (!isMobile()) {
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Of Quality
            </div>
          }
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showQualityFlasks"
            [(ngModel)]="filter.showQualityFlasksMinQuality" (change)="updateFilter()">
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showQualityCharms">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showQualityCharms"
            (click)="toggleShowQualityCharms()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Quality Charms" ruleId="charms-salvaging-quality" [additionalContent]="qualityCharmsStylePreview">
            <ng-template #qualityCharmsStylePreview>
              <app-equipment-tier-picker
                exampleName="Superior Golden Charm"
                [equipmentType]="EquipmentType.OtherCharmsQuality"
                [active]="filter.showQualityCharms"
                [disabled]="!filter.showQualityCharms"></app-equipment-tier-picker>
            </ng-template>
          </span>
          @if (!isMobile()) {
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Of Quality
            </div>
          }
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showQualityCharms"
            [(ngModel)]="filter.showQualityCharmsMinQuality" (change)="updateFilter()">
        </span>
      </div>

    </div>
    <div class="clear"></div>
  }
</div>
